import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Paper, Button } from '@mui/material';
import './NotificationsPage.css';

const NotificationsPage = () => {
  const [notificaciones, setNotificaciones] = useState([]);

  useEffect(() => {
    const fetchNotificaciones = () => {
      // Simular la obtención de notificaciones desde una API
      const notificacionesFalsas = [
        { id: 1, mensaje: 'Tienes un nuevo mensaje de John Doe', fecha: '2023-10-01' },
        { id: 2, mensaje: 'Tu perfil ha sido actualizado exitosamente', fecha: '2023-10-02' },
        { id: 3, mensaje: 'Nuevo comentario en tu publicación', fecha: '2023-10-03' },
      ];
      setNotificaciones(notificacionesFalsas);
    };

    fetchNotificaciones();
  }, []);

  const handleClearNotificaciones = () => {
    setNotificaciones([]);
  };

  return (
    <Container className="notifications-container">
      <Box my={4}>
        <Typography variant="h4" gutterBottom className="notifications-title">
          Notificaciones
        </Typography>
        <Paper className="notifications-paper">
          <List>
            {notificaciones.map((notificacion) => (
              <ListItem key={notificacion.id}>
                <ListItemText
                  primary={notificacion.mensaje}
                  secondary={notificacion.fecha}
                />
              </ListItem>
            ))}
          </List>
          {notificaciones.length === 0 && (
            <Typography variant="body1" className="no-notifications">
              No hay notificaciones disponibles.
            </Typography>
          )}
        </Paper>
        <Box mt={2} display="flex" justifyContent="flex-end">
          <Button variant="contained" color="secondary" onClick={handleClearNotificaciones}>
            Borrar Notificaciones
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default NotificationsPage;